import {markdown as markdownLang} from '@codemirror/lang-markdown'
import CodeMirror from '@github-ui/code-mirror'

import {activeBlockExtension} from './codemirror/extensions/active-block'
import {codeBlockExtension} from './codemirror/extensions/code-block'
import {headingExtension} from './codemirror/extensions/heading'
import {inlineExtension} from './codemirror/extensions/inline'
import styles from './HybridMarkdownEditor.module.css'
import {type MarkdownViewMode, ViewSwitch} from './ViewSwitch'

const extensions = [markdownLang(), activeBlockExtension, inlineExtension, headingExtension, codeBlockExtension]

export interface HybridMarkdownEditorProps {
  /** This is only the initial value. Changes to this value after mount are ignored. */
  value: string
  onChange: (value: string) => void
  disabled?: boolean
  onChangeViewMode?: (newViewMode: MarkdownViewMode) => void
}

export function HybridMarkdownEditor({value, onChange, disabled, onChangeViewMode}: HybridMarkdownEditorProps) {
  return (
    <div className={styles.container}>
      <div className={styles.toolbar}>
        <div className={styles.viewSwitch}>
          <ViewSwitch selectedView="hybrid" onViewSelect={onChangeViewMode} />
        </div>
        <div className={styles.formattingTools} />
      </div>

      <CodeMirror
        value={value}
        onChange={onChange}
        ariaLabelledBy="code-mirror-editor"
        spacing={{indentUnit: 2, indentWithTabs: false, lineWrapping: true}}
        extensions={extensions}
        isReadOnly={disabled}
      />
    </div>
  )
}

try{ HybridMarkdownEditor.displayName ||= 'HybridMarkdownEditor' } catch {}